import {
  REQUEST,
  FETCH_INIT_SUCCESS,
  USER_LOGIN_SUCCESS,
} from '../actions/action_types';
import { FETCH_LOTTERIES, FETCH_REFERRAL_CODE } from '../actionTypes/referral';

const initState = {
  ids: [],
  eventsById: null,
  dataNext: false,
  referralCode: {
    code: null,
    link: null,
  },
  marketing: {},
  fetchLotteriesState: REQUEST.INIT,
  fetchReferralCodeState: REQUEST.INIT,
};

export default (state = initState, action) => {
  switch (action.type) {
    case FETCH_LOTTERIES.LOADING:
      return {
        ...state,
        ids: [],
        eventsById: null,
        dataNext: false,
        fetchLotteriesState: REQUEST.LOADING,
      };
    case FETCH_LOTTERIES.SUCCESS: {
      const { data, dataNext } = action.payload;
      const newIds = [];
      const eventsObj = {};
      data.forEach(item => {
        const { id } = item;
        if (id) {
          newIds.push(id);
          eventsObj[id] = item;
        }
      });
      return {
        ...state,
        ids: newIds,
        eventsById: eventsObj,
        dataNext,
        fetchLotteriesState: REQUEST.SUCCESS,
      };
    }
    case FETCH_LOTTERIES.FAIL:
      return {
        ...state,
        fetchLotteriesState: REQUEST.FAIL,
      };
    case FETCH_REFERRAL_CODE.LOADING:
      return {
        ...state,
        referralCode: initState.referralCode,
        fetchReferralCodeState: REQUEST.INIT,
      };
    case FETCH_REFERRAL_CODE.SUCCESS: {
      const { share, marketing } = action.payload;
      const { code, url } = share;

      return {
        ...state,
        referralCode: {
          ...state.referralCode,
          link: url,
          code,
        },
        fetchReferralCodeState: REQUEST.SUCCESS,
        marketing: {
          ...state.marketing,
          ...marketing,
        },
      };
    }
    case FETCH_REFERRAL_CODE.FAIL:
      return {
        ...state,
        fetchReferralCodeState: REQUEST.FAIL,
      };
    case FETCH_INIT_SUCCESS: {
      const results = action.payload.results;
      let marketingObjInit = {};
      results.some(item => {
        const { key, value } = item;
        const isMarketing = key === 'Marketing';
        if (isMarketing) {
          marketingObjInit = value;
        }
        return isMarketing;
      });

      return {
        ...state,
        marketing: {
          ...state.marketing,
          ...marketingObjInit,
        },
      };
    }
    case USER_LOGIN_SUCCESS: {
      const marketing = action.payload?.marketing;

      if (marketing) {
        return {
          ...state,
          marketing: {
            ...state.marketing,
            ...marketing,
          },
        };
      }

      return state;
    }
    default:
      return state;
  }
};
